import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CannotContainOnlySpaceValidator } from 'src/app/directives/cannot-contain-only-space-validator.directive';

@Component({
  selector: 'app-client-online-settings',
  templateUrl: './client-online-settings.component.html'
})
export class ClientOnlineSettingsComponent implements OnInit {
  @Input('clientOnlineName') clientOnlineName!: string;
  @Input('useClientOnline') useClientOnline!: boolean;
  @Input('pinkwebPassword') pinkwebPassword!: string;
  @Input('pinkwebUrl') pinkwebUrl!: string;
  @Input('pinkwebUsername') pinkwebUsername!: string;
  @Output('UpdateOrganisationSettings') updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();
  form!: UntypedFormGroup;
  
  constructor(private formBuilder: UntypedFormBuilder, private activeModal: NgbActiveModal) {
    this.form = this.formBuilder.group({
      pinkwebUrl: new UntypedFormControl('', [Validators.required, CannotContainOnlySpaceValidator()]),
      pinkwebUsername: new UntypedFormControl('', [Validators.required, CannotContainOnlySpaceValidator()]),
      pinkwebPassword: new UntypedFormControl('', [Validators.required, CannotContainOnlySpaceValidator()])
    });
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  closeDialog() {
    this.activeModal.close(false);
  }

  save() {
    let settings: any[] = [];

    let url = (document.getElementById('PinkwebUrl') as HTMLInputElement).value;
    settings.push({key: 'PinkwebUrl', value: url});

    let username = (document.getElementById('PinkwebUsername') as HTMLInputElement).value;
    if(username !== '************') settings.push({key: 'PinkwebUsername', value: username});

    let password = (document.getElementById('PinkwebPassword') as HTMLInputElement).value;
    if(password !== '************') settings.push({key: 'PinkwebPassword', value: password});

    this.updateOrganisationSettings.emit(settings);
  }

}
